// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__l5pvH","button":"style_button__2jIHn"};